import { RequestResponse } from '@core/services/request/model/request.model';
import { ConsumptionRequest } from '../../model/consumption/consumption-request.model';
import { ConsumptionRequestApi } from '@core/api/model/consumption/consumption-request-api.model';
import { acJoin } from '@shared/pipes/join/join.pipe';
import { CodStatus, tagStatusDictionary } from '../../model/consumption/consumption-cod-status.enum';

export class ConsumptionRequestMapper {
  static requestFromApiToDomain(input: RequestResponse<Array<ConsumptionRequestApi>>): RequestResponse<Array<ConsumptionRequest>> {
    return {
      ...input,
      data: input.data.map(ConsumptionRequestMapper.fromApiToDomain),
    };
  }

  static fromApiToDomain(api: ConsumptionRequestApi): ConsumptionRequest {
    const sortedSocietyNames = [...new Set(api.instalaciones.map((i) => acJoin([i.nombreSociedad, i.cifSociedad], ' | ')))].sort();
    const sortedInstallationsNames = [...new Set(api.instalaciones.map((i) => acJoin([i.nombreInstalacion, i.cups], ' - ')))].sort();

    return {
      requestId: api.idPeticio,
      requestCode: api.codePeticion,
      startDate: api.fechaInicio,
      endDate: api.fechaFin,
      requestDate: api.fechaPeticion,
      isTime: api.isHoraria,
      codStatus: api.codEstado,
      descriptionStatus: api.descripcionEstado,
      societyCodes: [...new Set(api.instalaciones.map((i) => i.codigoSociedad))],
      societyNames: sortedSocietyNames,
      installationsCups: [...new Set(api.instalaciones.map((i) => i.cups))],
      installationsNames: sortedInstallationsNames,
      fileType: api.tipoFichero,
      tagStatusColumnTable: tagStatusDictionary[api.codEstado],
      isTimeColumnTable: api.isHoraria
        ? 'CONSUMPTION.REQUEST_LIST.TYPE_METRIC_OPTIONS.HOUR'
        : 'CONSUMPTION.REQUEST_LIST.TYPE_METRIC_OPTIONS.QUARTES_HOUR',
      documentDownload: api.codEstado === CodStatus.REALIZADA ? api.idPeticio : undefined,
    };
  }
}
